import { forwardRef } from "react";

import { t } from "i18n/i18n";
import {
  SquareIconButton,
  type SquareIconButtonProps,
} from "mds/components/buttons/SquareIconButton";
import { CrossRemoveIcon } from "mds/icons";

export type CloseButtonProps<T extends React.ElementType = "button"> = Omit<
  SquareIconButtonProps<T>,
  "kind" | "size"
> & {
  kind?: SquareIconButtonProps<T>["kind"];
  size?: SquareIconButtonProps<T>["size"];
};

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps<"button">>(
  ({ kind = "tertiary", size = "s", title = t("common.close"), ...props }, ref) => (
    <SquareIconButton kind={kind} ref={ref} size={size} title={title} {...props}>
      <CrossRemoveIcon />
    </SquareIconButton>
  ),
);

CloseButton.displayName = "CloseButton";
